import * as C from '../common/constants';
import FormHelperText from '@mui/material/FormHelperText';
import MenuBox from './MenuBox';
import SelectColorCode from './SelectColorCode';
import clsx from 'clsx';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { EMenus } from '../common/enums';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useSelector, useDispatch } from 'react-redux';
import { Fragment } from 'react';
import { storeData, clearData } from '../common/app/actions';
import queryString from 'query-string';

const useStyles = makeStyles(
  (theme: any): StyleRules =>
    createStyles({
      selectColorsStyle: {
        position: 'relative',
        width: '100%',
        // height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '10px',
      },
      titleStyle: {
        width: '100%',
        fontFamily: theme.typography.fontFamily,
        // fontWeight: 400,
        fontSize: '16px',
        color: `${COLORS.white} !important`,
        textAlign: 'center',
        paddingBottom: '20px',
        fontWeight: FONT_WEIGHT.bold,
      },
      colorsBoxStyle: {
        width: '100%',
        minHeight: '28px',
        boxSizing: 'border-box',
        // padding: '14px',
        display: 'flex',
        flexDirection: 'column',
      },
      colorsSeparatorStyle: {
        borderBottom: `1px solid ${COLORS.appGrey}`,
      },
      currentColorsStyle: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        background: '#262726',
        boxSizing: 'border-box',
        // padding: '10px',
        padding: '8px 8px 8px 12px',
        '& > :first-child': {
          display: 'none',
        },
      },
      currentColorBoxStyle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        // padding: '8px 8px 8px 12px',
        // justifyContent: 'space-between',
      },
      currentColorSquareStyle: {
        marginRight: '10px',
      },
      currentActiveStyle: {
        outline: `3px solid ${COLORS.red}`,
        // borderRadius: '4px',
      },
      currentColorTitleStyle: {
        fontFamily: theme.typography.fontFamily,
        // fontWeight: 400,
        fontSize: '16px',
        color: `${COLORS.white} !important`,
        whiteSpace: 'nowrap',
        paddingRight: '10px',
        fontWeight: FONT_WEIGHT.bold,
      },
      colorsStyle: {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',
        gap: '4px',
      },
      paletteStyle: {
        marginTop: '20px',
      },
      '@global': {
        '.MuiFormHelperText-root': {
          color: `${COLORS.lightGrey} !important`,
          margin: '0 !important',
          lineHeight: '14px !important',
        },
      },
      '@media only screen and (max-height: 840px)': {
        currentColorsStyle: {
          gap: '6px',
          padding: '6px 4px',
        },
        // currentColorBoxStyle: {
        //   padding: '4px 4px 4px 6px',
        // },
        currentColorTitleStyle: {
          fontSize: '12px',
        },
        currentActiveStyle: {
          outline: `1px solid ${COLORS.red}`,
        },
      },
      '@media only screen and (max-height: 750px)': {
        selectColorsStyle: {
          marginBottom: '10px',
        },
        currentColorsStyle: {
          gap: '2px',
          padding: '4px 4px',
        },
        paletteStyle: {
          marginTop: '10px',
        },
      },
      '@media only screen and (max-height: 650px)': {
        currentColorsStyle: {
          gap: '2px',
        },
        selectColorsStyle: {
          marginBottom: '6px',
        },
      },
      '@media only screen and (max-height: 580px)': {
        titleStyle: {
          fontSize: '14px',
          paddingBottom: '10px',
        },
        currentColorsStyle: {
          gap: '2px',
          padding: '4px 0px',
        },
      },
    })
);

const SelectColors = (): JSX.Element => {
  const classes = useStyles();
  const dispatch: any = useDispatch();

  const colorsData = useSelector((state: any) => state.app[C.SET_COLORS]);
  // const selectedColor = useSelector(
  //   (state: any) => state.app[C.SET_SELECTED_COLOR]
  // );

  const appData = useSelector((state: any) => state.app[C.APP_DATA]);
  const labels = appData.labels;

  if (!colorsData) {
    return null;
  }

  const onCurrentColorClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();

    // const rawNr = event.currentTarget.getAttribute('data-nr');
    // const nr = parseInt(rawNr);

    // const color = event.currentTarget.getAttribute('data-color');

    // dispatch(storeData({ nr, color }, C.SET_SELECTED_COLOR));
    // dispatch(clearData(C.SET_WINGLIGHT));
  };

  const getColors = (colorData, index) => {
    // if (!colorData?.visible) {
    //   return null;
    // }

    // const isActive = selectedColor?.nr === index + 1;
    // const isUnactive = Boolean(selectedColor) && !isActive;
    const colorCode = colorData.default;

    return (
      <Fragment key={index}>
        <div className={classes.colorsSeparatorStyle} />
        <div
          className={clsx(
            classes.currentColorBoxStyle
            // isActive && classes.currentActiveStyle
          )}
          key={index}
          onClick={onCurrentColorClick}
          data-nr={index + 1}
          data-color={colorCode}
        >
          <div className={classes.currentColorTitleStyle}>{`COLOR ${
            index + 1
          }`}</div>
          {/* <SelectColorCode
          key={index}
          color={colorCode}
          // nr={index + 1}
          // onClick={onCurrentColorClick}
          // isActive={isActive}
          // isUnactive={isUnactive}
          // isCircle
          isFullWidth
          className={classes.currentColorSquareStyle}
        /> */}
          <div className={clsx(classes.colorsStyle)}>
            {colorData.sub.map((colorCode, colorIndex) =>
              getPaletteColor(colorCode, colorIndex, colorData, index)
            )}
          </div>
        </div>
      </Fragment>
    );
  };

  const onNewColorClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();

    const color = event.currentTarget.getAttribute('data-color');
    const rawPaletteNr = event.currentTarget.getAttribute('data-palette-nr');
    const paletteNr = parseInt(rawPaletteNr);

    dispatch(storeData({ paletteNr, color }, C.SET_CURRENT_COLOR));
  };

  const getPaletteColor = (colorCode, index, colorData, paletteIndex) => {
    const isActive = colorCode === colorData.default;

    return (
      <SelectColorCode
        key={index}
        color={colorCode}
        nr={index + 1}
        paletteNr={paletteIndex}
        onClick={onNewColorClick}
        isActive={isActive}
      />
    );
  };

  const filteredColorsData = colorsData.filter(
    (colorData) => colorData?.visible
  );

  const parsed: any = queryString.parse(window.location.search);
  // const currentColorData = colorsData[selectedColor.nr - 1];
  // const COLOR_PALETTE = currentColorData.sub;
  // parsed?.limit === 'true' ? currentColorData.sub : palette;

  return (
    <>
      <div className={classes.selectColorsStyle}>
        {/* <MenuBox title={title} /> */}
        <div className={classes.titleStyle}>{labels?.schemeColorsLabel}</div>
        <div className={classes.colorsBoxStyle}>
          <div className={classes.currentColorsStyle}>
            {filteredColorsData.map(getColors)}
          </div>
          {/* {Boolean(selectedColor) && (
            <div className={clsx(classes.colorsStyle, classes.paletteStyle)}>
              {COLOR_PALETTE.map(getPaletteColor)}
            </div>
          )} */}
        </div>
      </div>
      <FormHelperText>{labels?.colorDisclaimerLabel}</FormHelperText>
    </>
  );
};

export default SelectColors;
